export const settingsConstants = {
    SETTINGS_CHANGE_THEME_REQUEST: "SETTINGS_CHANGE_THEME_REQUEST",
    SETTINGS_CHANGE_THEME_SUCCESS: "SETTINGS_CHANGE_THEME_SUCCESS",
    SETTINGS_CLEAR: "SETTINGS_CLEAR"
  };
  